import { SafeUrl } from '@angular/platform-browser';
export interface MailBody {
  mailTo: string;
  mailCC?: string;
  mailSubject: string;
  mailText: string;
  chartName: string;
  priority: boolean;
  base64Image: string;
  embedImage: boolean;
}

export interface ScreenshotChart {
  chartTitle: string;
  base64Image: string;
}

export enum ContactType {
  ONE_ON_ONE = 'oneOnOne',
  GROUP = 'group',
  MEETING = 'meeting',
  TEAM_CHANNEL = 'teamChannel',
  EMAIL = 'mail',
  EMAIL_GROUP = 'mailGroup',
}

export const CONTACT_TYPES_NAMES = {
  [ContactType.ONE_ON_ONE]: 'Direct Message',
  [ContactType.GROUP]: 'Group chat',
  [ContactType.MEETING]: 'Meeting',
  [ContactType.TEAM_CHANNEL]: 'Team Channel',
  [ContactType.EMAIL]: 'Email',
  [ContactType.EMAIL_GROUP]: 'Email Group',
};
export interface Contact {
  id: string;
  photo?: string | SafeUrl;
  displayName: string;
  customSubtitle?: string;
  mail?: string;
  type: ContactType;
  contacts?: Contact[];
}

export interface TeamChannelContact extends Contact {
  teamId: string;
}

export const USER_DEFAULT_PHOTO = 'assets/icons/sprite/default-photo-user.svg';
export const GROUP_DEFAULT_PHOTO =
  'assets/icons/sprite/default-photo-group.svg';
